export default __webpack_public_path__ + "../img/71fe374261ee95ce71b45cc91962401f.png";